<user-navigation></user-navigation>

<div class="container-fluid summary_bg overflow-hidden" id="bg_container">

    <div class="row">

        <div class="col-lg-6 col-md-10 m-auto col-12">

            <div class="container mt-6 text-white div-title">
                <h3 class="title_11">Marketing Collateral</h3>

                <p>A collection of resources and information to support you to promote Take a Breath.</p>
            </div>

            <div class="container mb-2">
                <ul id="top-menu">
                    <li class="ml-sm-0" [ngClass]="{'active': activateSummary}">
                        <a href="javascript:void(0)" (click)="activateSeries(5)">Summary</a>
                    </li>
                    <li [ngClass]="{'active': activateSeriesOne}">
                        <a href="javascript:void(0)" (click)="activateSeries(1)">Series  1</a>
                    </li>
                    <li [ngClass]="{'active': activateSeriesTwo}">
                        <a href="javascript:void(0)" (click)="activateSeries(2)">Series  2</a>
                    </li>
                    <li [ngClass]="{'active': activateSeriesThree}">
                        <a href="javascript:void(0)" (click)="activateSeries(3)">Series  3</a>
                    </li>
                    <li [ngClass]="{'active': activateSeriesFour}">
                        <a href="javascript:void(0)" (click)="activateSeries(4)">Series  4</a>
                    </li>
                </ul>
            </div>

            <div class="container pb-5 mt-5" *ngIf="activateSummary">
                <div id="series_1_1" class="pt-10 series-content">
                    <p class="font-20">
                        The Take a Breath digital health platform includes breathe training, team activations, learning modules and content audio pods.
                    </p>
                    <p class="mt-3">
                        You’ll find information here regarding the activations and how to run them, as well as a set of promotional collateral and brand assets for you to use.
                    </p>
                </div>

                <div id="series_1_2" class="pt-12 series-content">
                    <div class="row">
                        <div class="col-md-3 align-self-center">
                            <img class="w-100" src="assets/images/marketing/ian-keefe-NBQhCKtg_9Y-unsplash.png" alt="anxiety">
                        </div>
                        <div class="col-md-9 align-self-center">
                            <h4 class="row-title">Email Templates</h4>
                            <p>Use these templates, or tailor them to suit your comms as you roll out the Take a Breath programme.</p>
                            <a download="anxiety.png" href="assets/images/marketing/download_1_3.png"><i class="fa fa-cloud-download"></i> Download here</a>
                        </div>
                    </div>
                </div>

                <div id="series_1_3" class="pt-12 series-content">
                    <div class="row">
                        <div class="col-md-3 align-self-center">
                            <img class="w-100" src="assets/images/marketing/andrzej-kryszpiniuk-4wFqHZ1ONnM-unsplash.png" alt="anxiety">
                        </div>
                        <div class="col-md-9 align-self-center">
                            <h3 class="row-title">Posters</h3>
                            <p>Print these for your workspaces; set them to your digital screens, or create your own using the brand assets provided.</p>
                            <a download="anxiety.png" href="assets/images/marketing/download_1_3.png"><i class="fa fa-cloud-download"></i> Download here</a>
                        </div>
                    </div>
                </div>

                <div id="series_1_4" class="pt-12 series-content">
                    <div class="row">
                        <div class="col-md-3 align-self-center">
                            <img class="w-100" src="assets/images/marketing/andrzej-kryszpiniuk-4wFqHZ1ONnM-unsplash2.png" alt="anxiety">
                        </div>
                        <div class="col-md-9 align-self-center">
                            <h3 class="row-title">Desk Drops</h3>
                            <p>Affix a selection of these to desks, tables, doors, bathroom counters as another touch point for your teams.</p>
                            <a download="anxiety.png" href="assets/images/marketing/download_1_3.png"><i class="fa fa-cloud-download"></i> Download here</a>
                        </div>
                    </div>
                </div>

                <div id="series_1_5" class="pt-12 series-content">
                    <div class="row">
                        <div class="col-md-3 align-self-center">
                            <img class="w-100" src="assets/images/marketing/ian-keefe-NBQhCKtg_9Y-unsplash.png" alt="anxiety">
                        </div>
                        <div class="col-md-9 align-self-center">
                            <h3 class="row-title">Videos and Articles </h3>
                            <p>Browse these articles + videos and share them via internal workplace social channels or add to your email comms.</p>
                            <a download="anxiety.png" href="assets/images/marketing/download_1_3.png"><i class="fa fa-cloud-download"></i> Download here</a>
                        </div>
                    </div>
                </div>

                <div id="series_1_6" class="pt-12 series-content">
                    <div class="row">
                        <div class="col-md-3 align-self-center">
                            <img class="w-100" src="assets/images/marketing/andrzej-kryszpiniuk-4wFqHZ1ONnM-unsplash2.png" alt="anxiety">
                        </div>
                        <div class="col-md-9 align-self-center">
                            <h3 class="row-title">Social Posts</h3>
                            <p>Encourage engagement and gifting by sharing posts and stats to your internal workplace social channels.</p>
                            <a download="anxiety.png" href="assets/images/marketing/download_1_3.png"><i class="fa fa-cloud-download"></i> Download here</a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container pb-5" *ngIf="activateSeriesOne || activateSeriesTwo || activateSeriesThree || activateSeriesFour">
                <app-series-one *ngIf="activateSeriesOne"></app-series-one>
                <app-series-two *ngIf="activateSeriesTwo"></app-series-two>
                <app-series-three *ngIf="activateSeriesThree"></app-series-three>
                <app-series-four *ngIf="activateSeriesFour"></app-series-four>
            </div>

        </div>
    </div>

</div>